import React from "react";
import styles from './view_selector.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGrip, faList } from "@fortawesome/free-solid-svg-icons";

export default function ViewSelector({viewType, setViewType}) {
    return (
        <div className={styles.container}>
            <div className={`${styles.itemView} ${viewType === 'items' ? styles.selected : ''}`} onClick={() => setViewType('items')}>
                <FontAwesomeIcon icon={faGrip} color={viewType === 'items' ? '#ED8B00' : '#999'} size="sm" />
            </div>
            <div className={`${styles.listView} ${viewType === 'list' ? styles.selected : ''}`} onClick={() => setViewType('list')}>
                <FontAwesomeIcon icon={faList} color={viewType === 'list' ? '#ED8B00' : '#999'} size="sm" />
            </div>
        </div>
    )
}
